import { render } from "./MainTitle.vue?vue&type=template&id=2ea8bebe"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2ea8bebe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ea8bebe', script)) {
    api.reload('2ea8bebe', script)
  }
  
  module.hot.accept("./MainTitle.vue?vue&type=template&id=2ea8bebe", () => {
    api.rerender('2ea8bebe', render)
  })

}

script.__file = "src/views/services/pageTitles/MainTitle.vue"

export default script